import { render, staticRenderFns } from "./Bottom.vue?vue&type=template&id=6efe84d0&scoped=true&"
import script from "./Bottom.vue?vue&type=script&lang=js&"
export * from "./Bottom.vue?vue&type=script&lang=js&"
import style0 from "./Bottom.vue?vue&type=style&index=0&id=6efe84d0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6efe84d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6efe84d0')) {
      api.createRecord('6efe84d0', component.options)
    } else {
      api.reload('6efe84d0', component.options)
    }
    module.hot.accept("./Bottom.vue?vue&type=template&id=6efe84d0&scoped=true&", function () {
      api.rerender('6efe84d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Layout/Bottom.vue"
export default component.exports